export default {
  meta: {
    title: '订单管理',
    url: '/order/manage', // 埋点用，记录所属模块
    // eventId: 'f6eb6311-de88-4564-b70e-2202b84cecd1'
  },
};
